import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { Locale } from "@/lib/i18n";
import { toLocalizedPath } from "@/lib/i18n";
import { DoNotSellLink, ManagePrivacyChoicesButton } from "@/components/ManagePrivacyChoicesButton";
const FOOTER_COPY = {
  ko: {
    site: "모두의 테스트",
    terms: "이용약관",
    privacy: "개인정보처리방침",
    faq: "자주 묻는 질문",
    support: "문의하기",
    contact: "제휴 문의"
  },
  en: {
    site: "All Tests",
    terms: "Terms",
    privacy: "Privacy",
    faq: "FAQ",
    support: "Support",
    contact: "Partnerships"
  }
} as const satisfies Record<Locale, Record<string, string>>;

// 사업자 정보는 전자상거래법상 표기 의무 항목으로, 한국어 정본을 로케일 무관하게 노출한다.
const BUSINESS_INFO = {
  company: "심플소프트",
  owner: "권도원",
  registrationNo: "213-28-00968",
  mailOrderNo: "2024-창원성산-0622",
  address: "경상남도 창원시 성산구 외동반림로126번길 53, 206호",
  tel: "070-4509-1444",
  email: "contact@simplesoft.me",
  host: "Railway, Cloudflare, Inc."
} as const;
export default function Footer(t0) {
  const $ = _c(48);
  const {
    locale: t1
  } = t0;
  const locale = t1 === undefined ? "ko" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Date().getFullYear();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const year = t2;
  const copy = FOOTER_COPY[locale];
  let t3;
  if ($[1] !== copy.site) {
    t3 = <span>© {year} {copy.site} · modu-test.com</span>;
    $[1] = copy.site;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-slate-300">·</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== locale) {
    t5 = toLocalizedPath("/legal/terms", locale);
    $[4] = locale;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== copy.terms || $[7] !== t5) {
    t6 = <Link href={t5} className="hover:text-slate-600">{copy.terms}</Link>;
    $[6] = copy.terms;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-slate-300">·</span>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== locale) {
    t8 = toLocalizedPath("/legal/privacy", locale);
    $[10] = locale;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== copy.privacy || $[13] !== t8) {
    t9 = <Link href={t8} className="hover:text-slate-600">{copy.privacy}</Link>;
    $[12] = copy.privacy;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-slate-300">·</span>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== locale) {
    t11 = toLocalizedPath("/faq", locale);
    $[16] = locale;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== copy.faq || $[19] !== t11) {
    t12 = <Link href={t11} className="hover:text-slate-600">{copy.faq}</Link>;
    $[18] = copy.faq;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-slate-300">·</span>;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== locale) {
    t14 = toLocalizedPath("/support", locale);
    $[22] = locale;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== copy.support || $[25] !== t14) {
    t15 = <Link href={t14} className="hover:text-slate-600">{copy.support}</Link>;
    $[24] = copy.support;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="text-slate-300">·</span>;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== locale) {
    t17 = toLocalizedPath("/contact", locale);
    $[28] = locale;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== copy.contact || $[31] !== t17) {
    t18 = <Link href={t17} className="hover:text-slate-600">{copy.contact}</Link>;
    $[30] = copy.contact;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t12 || $[34] !== t15 || $[35] !== t18 || $[36] !== t3 || $[37] !== t6 || $[38] !== t9) {
    t19 = <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1">{t3}{t4}{t6}{t7}{t9}{t10}{t12}{t13}{t15}{t16}{t18}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t18;
    $[36] = t3;
    $[37] = t6;
    $[38] = t9;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5"><span>{BUSINESS_INFO.company}</span><span className="text-slate-300">·</span><span>대표 {BUSINESS_INFO.owner}</span><span className="text-slate-300">·</span><span>사업자등록번호 {BUSINESS_INFO.registrationNo}</span><span className="text-slate-300">·</span><span>통신판매업신고 {BUSINESS_INFO.mailOrderNo}</span></div>;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5"><span>{BUSINESS_INFO.address}</span></div>;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="mt-3 flex flex-col items-center gap-y-0.5 text-[11px] leading-relaxed text-slate-400">{t20}{t21}<div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5"><a href={`tel:${BUSINESS_INFO.tel}`} className="hover:text-slate-600">{BUSINESS_INFO.tel}</a><span className="text-slate-300">·</span><a href={`mailto:${BUSINESS_INFO.email}`} className="hover:text-slate-600">{BUSINESS_INFO.email}</a><span className="text-slate-300">·</span><span>호스팅 제공: {BUSINESS_INFO.host}</span></div></div>;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== locale) {
    t23 = locale === "en" ? <div className="mt-2 flex flex-wrap items-center justify-center gap-2 text-[11px] text-slate-500"><DoNotSellLink /><span className="text-slate-300">·</span><ManagePrivacyChoicesButton locale="en" className="text-[11px] text-slate-500 underline-offset-2 hover:text-slate-700 hover:underline" /></div> : null;
    $[43] = locale;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t19 || $[46] !== t23) {
    t24 = <footer className="pt-4 text-center text-xs text-slate-400">{t19}{t22}{t23}</footer>;
    $[45] = t19;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  return t24;
}